import { MicroFrontend } from '@praxis/component-microfrontend'
import { MFEProps } from './MFEProps'
import { envConfigs } from '../apiConfig'
import LoadingPage from 'layout/LoadingPage'
import { useContext } from 'react'
import { UserContext } from '../App/UserContext'

export type TileMFEProps = MFEProps

export const TileMFE = ({ environment }: TileMFEProps) => {
  const { sparkUser, isDark } = useContext(UserContext)

  return (
    <MicroFrontend
      environment={environment}
      src={envConfigs[environment].tile.mfeSrc}
      isPLMView
      Loading={LoadingPage}
      isDarkPLM={isDark}
      plmUser={sparkUser}
    />
  )
}
